export const ENDPOINTS = {
  LINK_PREVIEW: '/core/link_preview/',
  EMAIL_SIGNUP: '/pxauth/email_signup/',
  EMAIL_SIGNIN: '/pxauth/email_signin/',
  RESET_PASSWORD: '/pxauth/reset_password/',
  USER_SHIPPING_INFO: '/core/user_shipping_info/', // New endpoint for shipping info
  USER_PROFILE: '/core/user_profile/', // New endpoint for shipping info
  TIKTOK_VERIFY: '/core/tiktok/image-verify/',
};

export default ENDPOINTS;
